<div [class.bg-violet-100]="aside$ | async" [class.dark:bg-[#252c5f]]="aside$ | async" class="flex flex-col justify-between h-full">

    <div class="overflow-y-auto">

        <div class="mx-auto lg:mx-0 lg:max-w-none flex items-center justify-between px-3 py-3">
            <h2 class="text-lg text-secondary-900 dark:text-white font-semibold">Edit</h2>

            <div class="flex">
                <button class="flex items-end hover:opacity-75 mr-3">
                    <svg viewBox="0 0 18 18" class="w-5 h-5 fill-secondary-900 dark:fill-white" fill="none">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2H16V16H12V2ZM10 2H2L2 16H10V2ZM0 2C0 0.89543 0.895431 0 2 0H16C17.1046 0 18 0.895431 18 2V16C18 17.1046 17.1046 18 16 18H2C0.89543 18 0 17.1046 0 16V2Z" />
                    </svg>
                </button>
                <button (click)="hideAside()" class="flex lg:hidden items-end hover:opacity-75">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5 fill-secondary-900 dark:fill-white">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
            </div>
        </div>

        <!-- Edit -->
        <div id="edit" class="px-3 py-3">

            Edit

        </div>
        <!-- / Edit -->

    </div>

</div>
